import { defineMessages } from 'react-intl';

const doNotContactTranslations = defineMessages({
    ng_doNotContact_lastNameColumn: {
        id: 'ng_doNotContact_lastNameColumn',
        defaultMessage: 'LAST NAME'
    },
    ng_doNotContact_firstNameColumn: {
        id: 'ng_doNotContact_firstNameColumn',
        defaultMessage: 'FIRST NAME'
    },
    ng_doNotContact_deviceColumn: {
        id: 'ng_doNotContact_deviceColumn',
        defaultMessage: 'DEVICE'
    },
    ng_doNotContact_lastModifiedColumn: {
        id: 'ng_doNotContact_lastModifiedColumn',
        defaultMessage: 'LAST MODIFIED'
    },
    ng_doNotContact_title: {
        id: 'ng_doNotContact_title',
        defaultMessage: 'Do Not Contact'
    },
    ng_doNotContact_listTitle: {
        id: 'ng_doNotContact_listTitle',
        defaultMessage: 'Do Not Contact List'
    },
    ng_doNotContact_subtitle: {
        id: 'ng_doNotContact_subtitle',
        defaultMessage: 'View and manage the Do Not Contact list'
    },
    ng_doNotContact_addTitle: {
        id: 'ng_doNotContact_addTitle',
        defaultMessage: 'Add Contact'
    },
    ng_doNotContact_addTitle_success: {
        id: 'ng_doNotContact_addTitle_success',
        defaultMessage: 'Add Contact to Do Not Contact List'
    },
    ng_doNotContact_emptyTable_subtitle: {
        id: 'ng_doNotContact_emptyTable_subtitle',
        defaultMessage: 'Create a list of contact records that will not be contacted. Start by adding contacts below.'
    },
    ng_doNotContact_discardDescription: {
        id: 'ng_doNotContact_discardDescription',
        defaultMessage: 'Changes to the contact will not be saved.'
    },
    ng_contact_DoNotContactsList_contactDeleteModalTitle: {
        id: 'ng_contact_DoNotContactsList_contactDeleteModalTitle',
        defaultMessage: 'Delete {selectedContactsCount, plural, one {Contact} other {Contacts}}'
    },
    ng_contact_DoNotContactsList_DeviceExist: {
        id: 'ng_contact_DoNotContactsList_DeviceExist',
        defaultMessage: 'This device has already been added to the Do Not Contact list.'
    },
    ng_doNotContact_CreateEdit_OneDevice_ValidationMessage: {
        id: 'ng_doNotContact_CreateEdit_OneDevice_ValidationMessage',
        defaultMessage: 'At least one device is required to save contact.'
    },
    ng_doNotContact_SMS: {
        id: 'ng_doNotContact_SMS',
        defaultMessage: 'SMS: {0}'
    },
    ng_doNotContact_VOICE: {
        id: 'ng_doNotContact_VOICE',
        defaultMessage: 'VOICE: {0}'
    },
    ng_doNotContact_EMAIL: {
        id: 'ng_doNotContact_EMAIL',
        defaultMessage: 'EMAIL: {0}'
    },
    ng_contact_DoNotContactsList_successContent: {
        id: 'ng_contact_DoNotContactsList_successContent',
        defaultMessage: 'Successfully deleted {count, plural, one {1 contact} other {# contacts}}'
    },
    ng_doNotContact_CreateEdit_Email_ValidationMessage: {
        id: 'ng_doNotContact_CreateEdit_Email_ValidationMessage',
        defaultMessage: 'Email address field must contain a valid email address.'
    },
    ng_contact_DoNotContactsList_contactDeleteAllModalTitle: {
        id: 'ng_contact_DoNotContactsList_contactDeleteAllModalTitle',
        defaultMessage: 'Are you sure you want to delete all contacts?'
    },
    ng_doNotContact_DoNotContactsList_phone_NumericValidation: {
        id: 'ng_doNotContact_DoNotContactsList_phone_NumericValidation',
        defaultMessage: 'Phone numbers must be numeric characters only.'
    }
});

export default doNotContactTranslations;
